import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer"]

  connect() {
    console.log("✅ menu-drawer connected")
  }

   open() {
    console.log("👆 open called")

    document.body.classList.add("overflow-hidden") // ← scroll lock
    this.drawerTarget.classList.remove("hidden")
    setTimeout(() => this.drawerTarget.classList.add("show"), 10)
  }

  close() {
    console.log("👋 close called")

    this.drawerTarget.classList.remove("show")
    setTimeout(() => {
      this.drawerTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden") // ← remove scroll lock
    }, 300)
  }

  _onEscape = (event) => {
    if (event.key === "Escape") this.close()
  }
}